<template>
<!-- eslint-disable max-len -->
<list-page
  name="Role"
  use="_id"
  :display="display"
  page-prefix="/blade/roles"
  :fetch="getRoles"
  :remove="deleteRole"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getRoles',
      'deleteRole',
    ]),
    display({ name: roleName, updated }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${roleName} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/RolesList.vue